import axios from 'axios';
class ApiService {
  async register(name, email, country) {
    try {
      const response = await axios.post(
        'https://navidad-api.sanmartinbakery.com/api/register',
        {
          name,
          email,
          country,
        },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Hubo un problema durante el registro:', error.response);
      throw error;
    }
  }

  async login(email, password) {
    try {
      const response = await axios.post(
        'https://navidad-api.sanmartinbakery.com/api/login',
        {
          email,
          password,
        },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Hubo un problema durante el inicio de sesión:', error.response);
      throw error;
    }
  }

  async generarCupon(usuario_canje, country) {
    try {
      const response = await axios.post(
        'https://navidad-api.sanmartinbakery.com/api/generar-cupon',
        { usuario_canje, 
          country
        },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Hubo un problema al generar el cupón:', error);
      if (error.response) {
        console.error('Respuesta del servidor:', error.response.data);
      }
      throw error;
    }
  }

  async getCanjesPorFecha(country) {
    try {
      const response = await axios.get(
        `https://navidad-api.sanmartinbakery.com/api/cupones-por-fecha?country=${country}`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Hubo un problema al obtener los canjes por fecha:', error);
      if (error.response) {
        console.error('Respuesta del servidor:', error.response.data);
      }
      throw error;
    }
  }
}
export default ApiService;